import React from "react";
import Review from "../components/Review";

const ReviewPage = function (props) {
  return <Review collection={props.collection} />;
};

export default ReviewPage;
